"use strict";exports.__esModule = true;exports.symbol = symbol;function symbol() {
  // eslint-disable-next-line max-len,quotes
  return '<symbol viewbox="0 0 12 9" id=icon-tick-small><path fill-rule=evenodd d="M11.714.29a1 1 0 00-1.41 0l-6.3 6.3-2.29-2.3a1.004 1.004 0 00-1.42 1.42l3 3a1 1 0 001.41 0l7-7a1 1 0 00.01-1.42z"></path></symbol>';
}